import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=0b0c7eda&scoped=true"
var script = {}
import style0 from "./Loading.vue?vue&type=style&index=0&id=0b0c7eda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0c7eda",
  null
  
)

export default component.exports